{
  "version": 1,
  "asset_id": "a0b384a0-88f6-4a42-9445-d1043d8c957f",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/a0b384a0-88f6-4a42-9445-d1043d8c957f/cp523.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/a0b384a0-88f6-4a42-9445-d1043d8c957f/cp523.jpg",
  "original_filename": "cp523.jpg",
  "size": 112623,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:36Z"
}
